<template>
    <div>
        <van-loading v-if="loading" type="spinner" vertical color="#1989fa" class="loading">
        </van-loading>
        <div v-else class="message">
            <div>{{ message }}</div>
            <van-button v-if="btnShow" type="primary" @click="retry" class="button">点击重试</van-button>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { setCookie, base64Decode, getCookie } from "@/utils";
import request from "@/utils/request";
// import { initAgentConfig } from '@/utils/wxCodeAuth'


export default {
    name: "Auth",
    data() {
        return {
            query: {},
            loading: true,
            btnShow: true,
            message: "",
            state: {},
            target: "",
            agentId: 3,
            postId: 0,
            tag: ''
        };
    },
    async created() {
        await this.dataInit();
        await this.onLoad();
        // await initAgentConfig();   //禁止应用分享
    },
    methods: {
        async dataInit() {
            const { state, target, agentId, postId, storeId, tag } = this.$route.query;
            setCookie("storeId", storeId == "null" ? '' : storeId);
            this.agentId = agentId;
            this.state = JSON.parse(base64Decode(state));
            this.target = decodeURIComponent(target);
            this.tag = tag
            this.postId = postId == "null" ? '' : postId; //1:主任
            setCookie("postId", this.postId);
            await this.checkLoginResult();
        },

        //员工基本信息
        onLoad() {
            return request({
                url: '/my/getUserLogin',
                method: "get",
            })
                .then((res) => {
                    setCookie("toDoNum", res.data.backlog);
                    setCookie("empNo", res.data.empNo);
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                });
        },

        /**
         * 检查登录结果
         *
         * @returns {boolean}
         */
        async checkLoginResult() {
            if (this.state.code === 0) {
                const token = this.state.data.token;
                const expire = this.state.data.expire;
                setCookie("token", token, expire - 120);
                setCookie("agentId ", '3');
                this.loading = false;
                this.btnShow = false;

                await this.push();
                return;
            }

            this.showError(this.state.code, this.state.msg);
        },
        getLocation(url) {
            let query = {};
            const index = url.indexOf("?");
            if (index !== -1) {
                const params = url.substr(index + 1);
                const parr = params.split("&");
                for (const i of parr) {
                    const arr = i.split("=");
                    query[arr[0]] = arr[1];
                }
            }
            const path = url.split("?")[0];
            return { path, query: { ...query, agentId: this.agentId, tag: this.tag } };
        },

        async push() {
            const location = this.getLocation(this.target);
            this.$router.push(location);
        },

        showError(code, msg) {
            let message;
            switch (code) {
                case 100014:
                    message = "应用的可信域名错误，请检查微信后台配置";
                    break;
                case 100001:
                    message = "授权code码失效";
                    break;
                case 100008:
                    message = "账户异常，无法登录";
                    break;
                case 100013:
                case 100012:
                case 100016:
                    message = "参数错误";
                    break;
                default:
                    message = `登录失败请重新登录`;
            }
            console.error(msg);
            this.message = message;
            this.loading = false;
        },

        retry() {
            window.location.href = this.target;
        },
    },
};
</script>

<style lang="less" scoped>
.message,
.loading {
    background: #f3f4f8;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 600px;
}

.message {
    flex-direction: column;
    font-size: 30px;

    .button {
        margin-top: 50px;
    }
}
</style>
